import React from "react";
import DineInQrCard from "./DineInQrCard";
import "./styles/DineInQrGrid.css";

interface DineInQrGridProps {
  businessId: string;
  businessName: string;
  businessLogoUrl?: string;
  /** Table numbers to render, already resolved by the board. */
  tableNumbers: number[];
  onOpenQr: (tableNumber: number) => void;
}

/**
 * Every table's QR at once.
 *
 * Table numbers come from the board's tile list rather than being recounted
 * here, so the QR pane and the floor can never disagree about which tables
 * exist — including a table the API reported beyond the configured count.
 */
const DineInQrGrid: React.FC<DineInQrGridProps> = ({
  businessId,
  businessName,
  businessLogoUrl,
  tableNumbers,
  onOpenQr,
}) => (
  <div className="dine-in-qr-grid">
    {tableNumbers.map((tableNumber) => (
      <DineInQrCard
        key={tableNumber}
        businessId={businessId}
        businessName={businessName}
        businessLogoUrl={businessLogoUrl}
        tableNumber={tableNumber}
        onOpen={onOpenQr}
      />
    ))}
  </div>
);

export default DineInQrGrid;
